function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Inner Plugin Iframe"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.0625 20H19.9375C20.2193 20 20.4895 20.1054 20.6888 20.2929C20.8881 20.4804 21 20.7348 21 21C21 21.2652 20.8881 21.5196 20.6888 21.7071C20.4895 21.8946 20.2193 22 19.9375 22H5.0625C4.78071 22 4.51046 21.8946 4.3112 21.7071C4.11194 21.5196 4 21.2652 4 21C4 20.7348 4.11194 20.4804 4.3112 20.2929C4.51046 20.1054 4.78071 20 5.0625 20ZM4 15L14.625 5L17.8125 8L7.1875 18H4V15ZM15.6875 4L17.8125 2L21 5L18.8739 7.001L15.6875 4Z",
  fill: "#00B2E3"
}));

const SvgInnerPluginIframe2 = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInnerPluginIframe2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Inner Plugin Iframe (2).ddc75b54.svg";
export { ForwardRef as ReactComponent };